import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Homepage from './components/Homepage';
import Dashboard from './components/Dashboard';
import Login from './components/Login';
import Api from './components/Api/Api';
import LoadingSpinner from './components/LoadingSpinner';
import PrivacyPolicy from './components/static-pages/privacy-policy';
import TermsOfService from './components/static-pages/terms-of-service';
import TermsAndConditions from './components/static-pages/terms-and-conditions';
import { useContext } from 'react';
import AuthContext from './components/Auth';
import Signup from './components/Signup';
import Devices from './components/Devices';
import ChangePassword from './components/ChangePassword';
import ForgotPassword from './components/ForgotPassword';
import Plugins from './components/Plugins/Page';
import { FileSystemProvider } from './components/FileSystem';
import { PluginsProvider } from './components/Plugins';

function App() {
  const { isAuthenticated, isLoading } = useContext(AuthContext);
  return (
    <div className="App">
      <Router basename={process.env.REACT_APP_HOMEPAGE || '/'}>
        <Switch>
          <Route path="/privacy-policy" component={PrivacyPolicy} />
          <Route path="/terms-of-service" component={TermsOfService} />
          <Route path="/terms-and-conditions" component={TermsAndConditions} />
          <Route path="/api" component={Api} />
          <Route path="/devices" component={Devices} />
          <Route path="/login" component={Login} />
          <Route path="/signup" component={Signup} />
          <Route path="/forgot_password" component={ForgotPassword} />
          <Route path="/change_password/:token" component={ChangePassword} />
          <Route path="/plugins">
            <FileSystemProvider>
              <PluginsProvider>
                <Plugins />
              </PluginsProvider>
            </FileSystemProvider>
          </Route>
          <Route path="/:id" component={Homepage}>
            {isLoading && <LoadingSpinner />}
            {isAuthenticated && !isLoading && <Dashboard />}
            {!isAuthenticated && !isLoading && <Homepage />}
          </Route>
          <Route path="/" component={Homepage}>
            {isLoading && <LoadingSpinner />}
            {isAuthenticated && !isLoading && <Dashboard />}
            {!isAuthenticated && !isLoading && <Homepage />}
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
